import { DatabaseClient, getDatabaseClient } from '~/data/db/DatabaseClient';
import { resolveOfflineDb } from './offlineDatabase';
import QueryBuilder from "./queryBuilder";
import {AllUsers, Department} from "~/types";

export class AppOfflineService {

  constructor(private readonly databaseClient: DatabaseClient | null = getDatabaseClient()) {}

  private readonly qb: QueryBuilder = new QueryBuilder();
  private get SQLite() {
    return resolveOfflineDb(this.databaseClient) || null;
  }

  public resetDepartments(data: Department[]): Promise<void> {
    const db = this.SQLite;
    if (!db) return Promise.resolve();
    return new Promise<void>((resolve, reject) => {
      db.transaction(
        (tx) => {
          const { query: truncateQuery, params: truncateParams } = this.qb.truncate('Departments');
          tx.executeSql(truncateQuery, truncateParams);
          const { query: insertQuery, params: insertParams } = this.qb.insert('Departments', data);
          tx.executeSql(insertQuery, insertParams);
        },
        (e) => reject(e),
        resolve
      );
    });
  }

  public getAllDepartments(): Promise<Department[]> {
    const db = this.SQLite;
    if (!db) return Promise.resolve([]);
    return new Promise<Department[]>((resolve, reject) => {
      const { query, params } = this.qb.select('Departments');
      db.executeSql(query, params, (resultSet) => resolve(this.qb.getAllResult(resultSet)), (e) => reject(e));
    });
  }

  public resetUsers(data: AllUsers[]): Promise<void> {
    const db = this.SQLite;
    if (!db) return Promise.resolve();
    return new Promise<void>((resolve, reject) => {
      db.transaction(
        (tx) => {
          const { query: truncateQuery, params: truncateParams } = this.qb.truncate('Users');
          tx.executeSql(truncateQuery, truncateParams);
          const { query: insertQuery, params: insertParams } = this.qb.insert('Users', data);
          tx.executeSql(insertQuery, insertParams);
        },
        (e) => reject(e),
        resolve
      );
    });
  }

  public getAllUsers(): Promise<AllUsers[]> {
    const db = this.SQLite;
    if (!db) return Promise.resolve([]);
    return new Promise<AllUsers[]>((resolve, reject) => {
      const { query, params } = this.qb.select('Users');
      db.executeSql(query, params, (resultSet) => resolve(this.qb.getAllResult(resultSet)), (e) => reject(e));
    });
  }
}
